import { GuideTourStepCardBody } from './GuideTourStepCardBody'
import { GuideTourStepCardFooter } from './GuideTourStepCardFooter'
import { GuideTourStepCardHeader } from './GuideTourStepCardHeader'
import { useGuideTourStepCardModel } from './useGuideTourStepCardModel'
import * as S from './styles'

export const GuideTourStepCardView = () => {
  const model = useGuideTourStepCardModel()

  if (!model) {
    return null
  }

  const {
    cardRef,
    top,
    left,
    isInModalLayer,
    isSummaryOnly,
    currentStep,
    currentStepNumber,
    stepCount,
    isFirstStep,
    continueLabel,
    routeTourQueue,
    skippedStepNoticeMessage,
    isBlockedTargetInteractionWarningVisible,
    blockedTargetInteractionFeedbackKey,
    stepImageUrl,
    handleSkip,
    handleNext,
    handlePrev,
  } = model

  return (
    <S.Card
      ref={cardRef}
      elevated={isInModalLayer}
      data-testid="guide-tour-step-card"
      role="dialog"
      aria-labelledby={
        isSummaryOnly
          ? 'guide-tour-skipped-summary-title'
          : 'guide-tour-step-title'
      }
      aria-describedby={
        isSummaryOnly
          ? 'guide-tour-skipped-step-notice'
          : 'guide-tour-step-body'
      }
      style={{ top, left }}
    >
      <GuideTourStepCardHeader
        currentStep={currentStep}
        currentStepNumber={currentStepNumber}
        stepCount={stepCount}
        isSummaryOnly={isSummaryOnly}
        routeTourQueue={routeTourQueue}
        skippedStepNoticeMessage={skippedStepNoticeMessage}
        isBlockedTargetInteractionWarningVisible={
          isBlockedTargetInteractionWarningVisible
        }
      />

      <GuideTourStepCardBody
        currentStep={currentStep}
        isSummaryOnly={isSummaryOnly}
        stepImageUrl={stepImageUrl}
      />

      <GuideTourStepCardFooter
        continueLabel={continueLabel}
        isFirstStep={isFirstStep}
        isSummaryOnly={isSummaryOnly}
        blockedTargetInteractionFeedbackKey={
          blockedTargetInteractionFeedbackKey
        }
        onSkip={handleSkip}
        onNext={handleNext}
        onPrev={handlePrev}
      />
    </S.Card>
  )
}
